export function getPdfThumbSrc(pageElement) {
  if(!pageElement) return "";
  const canvas = [...pageElement.childNodes.entries()]
    .find((i) => i[1].nodeName === "CANVAS")?.[1];
  return canvas?.toDataURL() || "";
}